export default "dist/images/block-container-plain.f30c27d.png";